// modal.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Nullable } from '../../../types';

// Ce service gère les différents états des modales.
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalState = new BehaviorSubject<Nullable<string>>(null);

  showModal(modalId: string) {
    this.modalState.next(modalId);
  }

  hideModal() {
    this.modalState.next(null);
  }

  getModalState(): Observable<Nullable<string>> {
    return this.modalState.asObservable();
  }
}
